import React from 'react'

import WinnersBody from './../../molecules/WinnersBody/WinnersBody';
import EncabezadoGanadoras from './../../../assets/images/winners/cabezote-ganadoras.png';
import ModeloRuleta from '../../../assets/images/winners/modelo-ruleta.png';
import useMediaQuery from './../../../utils/useMediaQuery';
import './winner.scss'

function Winner() {
    const isMobile = useMediaQuery();
    return (
        <div className="f-roulette-winner">
            <div className="f-roulette-winner__images">
                <div className="">
                    <img
                        src={EncabezadoGanadoras}
                        alt="encabezado-sorteo"
                    />
                    <h2>2 premios de <span>Gs 5.000.000</span>
                    <br /> cada uno por semana</h2>
                </div>
                {!isMobile &&
                    <div className="">
                        <img src={ModeloRuleta} alt="modelo-ruleta" />
                    </div>
                }
            </div>
            <div className="f-roulette-winner__wrapper">
                <WinnersBody />
            </div>
        </div>
    )
}

export default Winner
